import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconPlushComfort = ({
  color = colorGray,
  width = '48',
  height = '36',
  className = '',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M22.135 10.332V7.677c-.008-.932-.756-1.682-1.675-1.676h-7.222a1.644 1.644 0 00-1.276.6h-.002A1.665 1.665 0 0010.68 6H3.414c-.917-.007-1.665.744-1.675 1.675v2.664c-.978.087-1.732.917-1.739 1.916v4.677c0 .222.176.401.395.401h3.06c.217 0 .395-.179.395-.4v-.536l16.3.006v.53c0 .221.176.4.395.4h3.06c.219 0 .395-.179.395-.4v-4.676c-.008-1.049-.834-1.9-1.864-1.925zm-9.522-3.27a.863.863 0 01.625-.26h7.222a.88.88 0 01.885.873v2.797a1.927 1.927 0 00-1.196 1.782v.158h-7.795V7.717a.922.922 0 01.258-.655zm-9.2-.258h7.265a.88.88 0 01.887.873v4.735H3.85v-.153a1.927 1.927 0 00-1.32-1.827V7.677a.88.88 0 01.885-.873zm-.354 9.728l-2.27-.001v-4.274a1.144 1.144 0 011.134-1.117c.613 0 1.116.493 1.137 1.117l-.001 4.275zm.79-.936v-2.382h16.3V15.6l-16.3-.004zm19.36.936l-2.27-.001v-4.274a1.146 1.146 0 011.135-1.117c.612 0 1.115.493 1.136 1.117v4.275z"
      clipRule="evenodd"
    />
  </svg>
);

IconPlushComfort.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconPlushComfort;
